import React, { Fragment, useState, useEffect } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Logout from "../welcome/Logout";
import GTCValidateLS from "src/notification/GTCValidateLS";
import Patients from "src/doctor/patients/Patient";
import Dashboard from "../doctor/DashboardAlternative";
// import Dashboard from "../doctor/Dashboard";
import AppointmentApprovedDetailsReadmore from "../doctor/appointment/AppointmentApprovedDetailsReadmore";
import StreamError from "../StreamError";
import CreateRoomOLd from "src/doctor/onlinecheckup/CreateRoomOLd";
import { PatientsUnRead } from "src/ContextAPI";
import Report from "src/doctor/Income/Report";
import axios from "axios";
// import CheckInternet from "src/utils/CheckInternet";
import Sidebar from "src/layout/Sidebar";
import RouteInvalid from "src/layout/RouteInvalid";

import {
  Home as HomeIcon,
  Users as PeopleAltIcon,
  FilePlus as FilePlusIcon,
  FileText as ListIcon,
  Database as ReportIcon,
  Calendar as AppointmentIcon,
  MessageSquare,
  CheckSquare,
  Lock,
  Package,
  Rss,
} from "react-feather";

import NewPatient from "src/doctor/patients/NewPatient";
import PatientHeader from "src/doctor/patients/PatientHeader";
import FullcalendarAppointment from "src/doctor/appointment-fullcalendar";
import FullcalendarAppointmentDetails from "src/doctor/appointment-fullcalendar/Details";
import AppointmentListByStatus from "src/doctor/alternatives/AppointmentListByStatus";
import AppointmentRequestForApproval from "src/doctor/alternatives/AppointmentRequestForApproval";
import GraphLaboratory from "src/doctor/patients/laboratory_new/graph/GraphLaboratory";
import CommentsList from "src/doctor/comment";
import DoctorsAccount from "src/doctor/account";
import IsMountedRef from "src/utils/IsMountedRef";
import WebPushNotification from "src/WebPush";
import DonascoRx from "src/utils/Rx/DonascoRx";
import { Badge } from "@material-ui/core";
import Management from "src/doctor/management";
import Services from "src/doctor/services";
// import RxForPedia from "src/utils/Rx/RxForPedia";
// import DocMariaDomingoRx from "src/utils/Rx/DocMariaDomingoRx";

const RouteDoctor = () => {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");

  const [patientNotifBadge, setPatientNotifBadge] = useState(0);

  const [unviewNotif, setUnviewNotif] = useState([]);
  const unviewNotifVirtual = [];
  // const [unviewNotifVirtual, setUnviewNotifVirtual] = useState([]);
  const [unviewNotifReady, setUnviewNotifReady] = useState(false);

  const [sidebarHeader, setSidebarHeader] = useState([]);
  // const [newReqForApproval, setNewReqForApproval] = useState(0);
  const newReqForApproval = 0;

  const ismounted = IsMountedRef();

  var interval = null;

  const updateDocNotif = (data) => {
    setPatientNotifBadge(data);
  };

  const getLocalNotifUnread = async () => {
    try {
      var params = {
        token: token,
        user_id: user_id,
        connection: "local",
      };

      const response = await axios.get(
        "doctor/unview/notification-unview-orders",
        { params }
      );
      const data = response.data;
      if (ismounted.current) {
        setUnviewNotif(data);
        setUnviewNotifReady(true);
      }
    } catch (error) {
      console.log("doctors unread notif error.", error);
    }
  };

  // const getVirtualNotifUnread = () => {
  //   CheckInternet.online()
  //     .then(async () => {
  //       try {
  //         var params = {
  //           token: token,
  //           user_id: user_id,
  //           connection: "online",
  //         };

  //         const response = await axios.get(
  //           "doctor/unview/notification-unview-orders",
  //           { params }
  //         );
  //         const data = response.data;
  //         if (ismounted.current) {
  //           setUnviewNotifVirtual(data);

  //         }
  //       } catch (error) {
  //         console.log("doctors unread notif error.", error);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(
  //         "no internet connection, notification from virtual not availbale.",
  //         error
  //       );
  //     });
  // };

  // const getRequestForAppointment = async () => {
  //   var formdata = new FormData();
  //   formdata.set("token", token);
  //   formdata.set("user_id", user_id);
  //   formdata.set("connection", "online");

  //   try {
  //     const response = await axios.post(
  //       "appointment/doctors/request-appointment-list",
  //       formdata
  //     );
  //     const data = response.data;
  //     if (ismounted.current) {
  //       setNewReqForApproval(data.length);
  //     }
  //   } catch (error) {
  //     console.log("unable to get new request for appointment.", error);
  //   }
  // };

  const initializeInterval = () => {
    getLocalNotifUnread();
    interval = setInterval(() => {
      // getRequestForAppointment();
      getLocalNotifUnread();
      // setTimeout(() => {
      //   getVirtualNotifUnread();
      // }, 3000);
    }, 30000);
  };

  const getSidebarHeaderInfo = async () => {
    try {
      var params = {
        token,
        user_id,
      };
      const response = await axios.get("doctor/sidebar/header-infomartion", {
        params,
      });
      if (ismounted.current) {
        setSidebarHeader(response.data);
      }
    } catch (error) {
      console.log("unable to get sdiebar header info.", error);
    }
  };

  useEffect(() => {
    GTCValidateLS.verifyLocalStorage();

    initializeInterval();
    getSidebarHeaderInfo();

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sidbarRoute = [
    {
      name: "Dashboard",
      show: true,
      icon: <HomeIcon color="white" />,
      path: "/clinic/app/doctor",
    },
    {
      name: "Appointment",
      show: true,
      icon: <AppointmentIcon color="white" />,
      path: "/clinic/app/doctor/appointment/calendar",
    },

    {
      name: "Virtual",
      show: true,
      icon: <Rss color="white" />,
      subitem: [
        {
          name: "Request",
          show: true,
          icon: (
            <Badge color="error" badgeContent={newReqForApproval}>
              {" "}
              <CheckSquare color="white" />{" "}
            </Badge>
          ),
          path: "/clinic/app/doctor/appointment/request",
        },
        {
          name: "Comments",
          show: true,
          icon: <MessageSquare color="white" />,
          path: "/clinic/app/doctor/comment/list",
        },
      ],
    },

    {
      name: "Patients",
      show: true,
      icon: <PeopleAltIcon color="white" />,
      subitem: [
        {
          name: "List",
          show: true,
          icon: <ListIcon size={20} color="white" />,
          path: "/clinic/app/doctor/patient/list",
        },
        {
          name: "New",
          show: true,
          icon: <FilePlusIcon size={20} color="white" />,
          path: "/clinic/app/doctor/patient/new",
        },
      ],
    },
    {
      name: "Services",
      show: true,
      icon: <Package color="white" />,
      path: "/clinic/app/doctors/services",
    },

    {
      name: "Accounts",
      show: true,
      icon: <Lock color="white" />,
      path: "/clinic/app/doctor/account",
    },

    {
      name: "Report",
      show: true,
      icon: <ReportIcon color="white" />,
      path: "/clinic/app/doctor/income/report",
    },
  ];

  return (
    <Fragment>
      <PatientsUnRead.Provider
        value={{
          doctorNotif: patientNotifBadge,
          updateDocNotif: updateDocNotif,
          unviewNotif: unviewNotif,
          unviewNotifVirtual: unviewNotifVirtual,
          personalInfo: sidebarHeader,
        }}
      >
        <BrowserRouter>
          <Sidebar
            notification={{
              enable: true,
              local: unviewNotif,
              virtual: unviewNotifVirtual,
              owner: "doctor",
            }}
            header={sidebarHeader}
            routes={sidbarRoute}
            module={"doctor"}
          />

          <Switch>
            <Route
              exact
              path="/"
              component={() => <Redirect to="/clinic/app/doctor" />}
            />

            <Route
              exact
              path="/clinic/"
              component={() => <Redirect to="/clinic/app/doctor" />}
            />

            <Route
              exact
              path="/clinic/app"
              component={() => <Redirect to="/clinic/app/doctor" />}
            />

            <Route exact path="/clinic/app/doctor" component={Dashboard} />

            <Route
              exact
              path="/clinic/app/doctor/account"
              component={DoctorsAccount}
            />

            <Route
              exact
              path="/clinic/app/doctor/patient/list"
              component={Patients}
            />

            <Route
              exact
              path="/clinic/app/doctor/patient/laboratory/:type/:patient_id"
              component={GraphLaboratory}
            />

            <Route
              exact
              path="/clinic/app/doctor/patient/new"
              component={NewPatient}
            />

            <Route
              exact
              path="/clinic/app/doctor/appointment/request"
              component={AppointmentRequestForApproval}
            />

            <Route
              exact
              path="/clinic/app/doctor/comment/list"
              component={CommentsList}
            />

            <Route
              exact
              path="/clinic/app/doctor/appointment/calendar"
              component={FullcalendarAppointment}
            />

            <Route
              exact
              path="/clinic/app/doctor/appointment/calendar/details/:from/:appid"
              component={FullcalendarAppointmentDetails}
            />

            <Route
              exact
              path="/clinic/app/doctor/appointment/calendar/list/:status"
              component={AppointmentListByStatus}
            />

            <Route
              exact
              path="/clinic/app/doctor/patient/details/:patient_id"
              component={PatientHeader}
            />

            <Route
              exact
              path="/clinic/app/doctor/income/report"
              component={Report}
            />

            <Route exact path="/clinic/app/logout" component={Logout} />

            <Route
              exact
              path="/clinic/app/doctor/appointment/patient/information/:patient_id"
              component={AppointmentApprovedDetailsReadmore}
            />

            <Route
              exact
              path="/clinic/app/doctor/appointment/room/:ref_number/:room_number"
              component={CreateRoomOLd}
            />

            <Route
              exact
              path="/clinic/app/streamerror"
              component={StreamError}
            />

            {/* doc donasco rx exclusive sample */}
            <Route
              exact
              path="/clinic/app/doctor/rx/:claim_id/:patient_id/:doctors_id"
              component={DonascoRx}
              // component={RxForPedia}
              // component={DocMariaDomingoRx}
            />

            <Route
              exact
              path="/clinic/app/doctors/management"
              component={Management}
            />

            <Route
              exact
              path="/clinic/app/doctors/services"
              component={Services}
            />

            <Route render={() => <RouteInvalid />} />
          </Switch>
        </BrowserRouter>
      </PatientsUnRead.Provider>

      {/* web push notification */}
      {!window.location.href.includes("192.168") && unviewNotifReady && (
        <WebPushNotification
          localNotif={unviewNotif}
          virtualNotif={unviewNotifVirtual}
        />
      )}
    </Fragment>
  );
};

export default RouteDoctor;
